module.exports = __webpack_public_path__ + "img/hospital_1.ad37c58e.png";